<!-- Slideout menu custom settings -->
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView == 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title"><span runat="server" cvLocalizedText langSection="Top_Call_Times_Module" langKey="Slideout_Section_Title">Display</span></div>
    <div class="custom-setting-section-context"><div class="text-truncate" style="max-width: 315px">{{getSlideoutContextSectionText()}}</div></div>
    <div class="custom-setting-section-body">
        <div>
            <div class="d-flex">
                <div class="flex-fill d-flex flex-column">
                    <label class="body-2" runat="server" cvLocalizedText langSection="Top_Call_Times_Module" langKey="Show_Top">Show Top</label>
                    <cv-single-select
                        id="topCallTimesTopCallCount" 
                        panelClass="cv-material-control" 
                        [value]="selectedTop?.Value"
                        [options]="topOptions"
                        primaryKey="Value"
                        label="Value"
                        style="max-width: 60px;"
                        (valueChange)="onSelectedTopChanged($event)"
                    ></cv-single-select>
                </div>
                <div class="flex-fill d-flex flex-column">
                    <label class="body-2" runat="server" cvLocalizedText langSection="Top_Call_Times_Module" langKey="Sort_By">Sort By</label>
                    <cv-single-select
                        id="topCallTimesSortBy" 
                        panelClass="cv-material-control" 
                        [placeholder]="getLocalizationString('None', 'None')"
                        [value]="settings.selectedSort?.Id"
                        [options]="settings.sortList"
                        primaryKey="Id"
                        label="Value"
                        style="max-width: 200px;"
                        (valueChange)="onSelectedSortChanged($event)"
                    ></cv-single-select>
                </div>
            </div>
            <div class="mt-3">
                <div class="p-0 d-flex flex-column"> 
                    <label class="body-2" runat="server" cvLocalizedText langSection="Top_Call_Times_Module" langKey="Metrics_Included">Metrics Included</label>
                    <cv-multi-select
                        panelClass="cv-material-control" 
                        [placeholder]="getLocalizationString('None', 'None')"
                        [value]="selectedMetricIds"
                        [options]="settings.includes"
                        primaryKey="Id"
                        label="CallMetricName"
                        style="width: 313px;"
                        [selectionText]="getMetricDisplay()"
                        (selectionChanged)="onSelectedMetricsChanged($event)"
                    ></cv-multi-select>
                </div>
            </div>
        </div>
    </div>
</cv-module-custom-setting-section>

<!-- Legacy custom settings-->
<ng-container *ngIf="moduleManager.settingsView != 'slideout'">
    <div cvModuleLegacyCustomSettingSection class="gridItemSettingsPanelCustomSettingsBottomItem" position="bottom" style="margin-top:16px;" [moduleManager]="moduleManager">
        <div class="d-flex flex-fill mt-2">
            <div class="d-flex flex-column">
                <label class="body-3" runat="server" cvLocalizedText langSection="Top_Call_Times_Module" langKey="Show_Top">Show Top</label>
                <cv-single-select
                    id="topCallTimesTopCallCount" 
                    panelClass="cv-material-control" 
                    class="pr-1"
                    [value]="selectedTop.Value"
                    [options]="topOptions"
                    primaryKey="Value"
                    label="Value"
                    (valueChange)="onSelectedTopChanged($event)"
                ></cv-single-select>
            </div>
            <div class="d-flex flex-column">
                <label class="body-3" runat="server" cvLocalizedText langSection="Top_Call_Times_Module" langKey="Sort_By">Sort By</label>
                <cv-single-select
                    id="topCallTimesSortBy" 
                    panelClass="cv-material-control" 
                    class="px-1"
                    [placeholder]="getLocalizationString('None', 'None')"
                    [value]="settings.selectedSort?.Id"
                    [options]="settings.sortList"
                    primaryKey="Id"
                    label="Value"
                    (valueChange)="onSelectedSortChanged($event)"
                ></cv-single-select>
            </div>
            <div class="d-flex flex-column">
                <label class="body-3" runat="server" cvLocalizedText langSection="Top_Call_Times_Module" langKey="Metrics_Included">Metrics Included</label>
                <cv-multi-select
                    panelClass="cv-material-control" 
                    class="pl-1"
                    [placeholder]="getLocalizationString('None', 'None')"
                    [value]="selectedMetricIds"
                    [options]="settings.includes"
                    primaryKey="Id"
                    label="CallMetricName"
                    [selectionText]="getMetricDisplay()"
                    (selectionChanged)="onSelectedMetricsChanged($event)"
                ></cv-multi-select>
            </div>
        </div>
    </div>
</ng-container>